import React from 'react';

import {Pie} from "react-chartjs-2";

const PieChart = (props) => {

    const dataPie = {
        labels: props.labels,
        datasets: [
            {
                label: 'Data',
                data: props.data,
                backgroundColor: ['#5B4FFF', '#22C55E'],
                borderColor: ['rgba(91, 79, 255, 0.8)', 'rgba(34, 197, 94, 0.8)'],
                borderWidth: 2,
                hoverBackgroundColor: ['#7B73FF', '#10B981'],
                hoverBorderColor: ['#5B4FFF', '#22C55E'],
                hoverBorderWidth: 3
            }
        ]
    };

    return (
        <Pie
            data={dataPie}
            options={{
                maintainAspectRatio : false,
                legend:{
                    "display": true,
                    "position": "bottom",
                    "reverse": true,
                    labels: {
                        fontColor: 'rgba(255, 255, 255, 0.8)',
                        fontSize: 12,
                        padding: 15
                    }
                },
                animation:{
                    animateScale: true
                },
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                tooltips: {
                    backgroundColor: 'rgba(26, 26, 46, 0.95)',
                    titleFontColor: '#FFFFFF',
                    bodyFontColor: 'rgba(255, 255, 255, 0.9)',
                    borderColor: 'rgba(91, 79, 255, 0.5)',
                    borderWidth: 1,
                    cornerRadius: 8,
                    displayColors: true
                }
            }}
        />
    )
};

export default PieChart;